import { createGlobalStyle } from 'styled-components';
import { theme } from './theme';

export const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${theme.typography.fontFamily};
    font-weight: ${theme.typography.weights.normal};
    line-height: ${theme.typography.lineHeights.normal};
    color: ${theme.colors.gray[900]};
    background-color: ${theme.colors.white};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: ${theme.typography.weights.semibold};
    line-height: ${theme.typography.lineHeights.tight};
    color: ${theme.colors.gray[900]};
  }

  h1 {
    font-size: ${theme.typography.sizes['5xl']};
    font-weight: ${theme.typography.weights.bold};
    
    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.typography.sizes['4xl']};
    }
  }

  h2 {
    font-size: ${theme.typography.sizes['4xl']};
    
    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.typography.sizes['3xl']};
    }
  }

  h3 {
    font-size: ${theme.typography.sizes['2xl']};
    
    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.typography.sizes.xl};
    }
  }

  p {
    font-size: ${theme.typography.sizes.lg};
    line-height: ${theme.typography.lineHeights.relaxed};
    color: ${theme.colors.gray[700]};
    
    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.typography.sizes.base};
    }
  }

  button {
    font-family: inherit;
    cursor: pointer;
    border: none;
    outline: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.gray[100]};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.gray[300]};
    border-radius: ${theme.borderRadius.full};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.gray[500]};
  }
`;